import { render } from "./PerfilScannerDNI.vue?vue&type=template&id=6845c742&lang=true"
import script from "./PerfilScannerDNI.vue?vue&type=script&lang=ts"
export * from "./PerfilScannerDNI.vue?vue&type=script&lang=ts"
script.render = render

export default script